<template>
  <component :is="$attrs.is || 'div'" v-if="$slots.default" class="max-w-9xl mx-auto px-m lg:px-xl">
    <slot />
  </component>
</template>
